export default {
    showPopup(network, url, text) {
        /* eslint-disable */
        // https://stackoverflow.com/a/16861050/203700
        // Fixes dual-screen position                         Most browsers      Firefox
        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

        const width = window.innerWidth
            ? window.innerWidth
            : document.documentElement.clientWidth
            ? document.documentElement.clientWidth
            : screen.width;
        const height = window.innerHeight
            ? window.innerHeight
            : document.documentElement.clientHeight
            ? document.documentElement.clientHeight
            : screen.height;

        let popupWidth = 420;
        let popupHeight = 250;
        const left = width / 2 - popupWidth / 2 + dualScreenLeft;
        const top = height / 2 - popupHeight / 2 + dualScreenTop;
        /* eslint-enable */

        url = encodeURIComponent(url);
        text = encodeURIComponent(text);

        let baseurl;
        if (network === "fb") {
            // https://developers.facebook.com/docs/sharing/reference/share-dialog
            const appID = FB_APP_ID;
            baseurl = `https://www.facebook.com/dialog/share?app_id=${appID}&display=popup&href=${url}&quote=${text}`;
        } else if (network === "tw") {
            // https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/guides/web-intent
            baseurl = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
        } else if (network === "li") {
            // https://developer.linkedin.com/docs/share-on-linkedin
            baseurl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&summary=${text}&source=WorkStep`;
            popupWidth = 370;
            popupHeight = 550;
        }

        window.open(
            baseurl,
            "socialinvite",
            `menubar=no,toolbar=no,width=${popupWidth},height=${popupHeight},top=${top},left=${left}`,
        );
    },
};
